import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Warning from '../../assets/svgs/Warning.svg';

const WarningMessage = ({ message, className }) => (
  <div className={clsx('flex items-center bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4', className)} role="alert">
    <Warning className="mr-1 h-5" />
    <span className="font-semibold">{message}</span>
  </div>
);

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};

WarningMessage.defaultProps = {
  className: undefined,
};

export default WarningMessage;
